import React from 'react'

function About() {
    return (
        <div id="about">
            <div className="abouts">
                <h4>Github Finder React App</h4>
                <p>Version: 1.0.0</p>
                <p>Developed By: Paul Izekor</p>
                <p>Inspired From: Lucky Izekor</p>
            </div>
        </div>
    )
}

export default About
